import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  constructor(private meta: Meta) {}

  configureViewport(): void {
    // Check if running on a mobile platform through Capacitor
    const isNativeMobile = Capacitor.isNativePlatform();

    if (isNativeMobile) {
      // Remove any existing viewport meta tag
      this.meta.removeTag('name="viewport"');

      // Mobile-specific viewport with user-scalable=no
      this.meta.addTag({
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      });
    }
  }
}
